module.exports = __webpack_public_path__ + "officialStatic/img/productB29.f20d269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/productB29.png
// module id = klxh
// module chunks = 0